import React from "react";
import classnames from "classnames";
import ClientHistoryItem from "./ClientHistoryItem";
import CallHistoryItem from "./CallHistoryItem";
import ProjectHistoryItem from "./ProjectHistoryItem";
import TicketHistoryItem from "./TIcketHistoryItem";
import TaskHistoryItem from "./TaskHistoryItem";
import InterventionHistoryItem from "./InterventionHistoryItem";
import ContractHistoryItem from "./ContractHistoryItem";
import BillingHistoryItem from "./BillingHistoryItem";
import NoteHistoryItem from "./NoteHistoryItem";
import DealHistoryItem from "./DealHistoryItem";
import EmailHistoryItem from "./EmailHistoryItem";
import SubscriptionHistoryItem from "./SubscriptionHistoryItem";
import EmailConversationHistoryItem from "./EmailConversationHistoryItem";
import {
  HistoryHeader,
  HistoryContent,
  HistoryOverview,
  HistoryAccountProfile,
  HistoryTitle,
  useHistoryItem,
  HistoryItemProvider
} from "./HistoryItemCommon";

export {
  HistoryTitle,
  HistoryHeader,
  HistoryOverview,
  HistoryContent,
  HistoryAccountProfile,
  useHistoryItem
} from "./HistoryItemCommon";

export const HistoryItemIndexContext = React.createContext();

export const HistoryItem = ({ item, index, className }) => {
  const {
    Call,
    Ticket,
    Project,
    Task,
    TimeCharge,
    Client,
    Contract,
    Billing,
    Note,
    Deal,
		Subscription,
		EmailConversation,
    Email
  } = item;

  let comp;
  if (Subscription) comp = <SubscriptionHistoryItem />;
  else if (Call) comp = <CallHistoryItem />;
  else if (Ticket) comp = <TicketHistoryItem />;
  else if (Project) comp = <ProjectHistoryItem />;
  else if (Task) comp = <TaskHistoryItem />;
  else if (TimeCharge) comp = <InterventionHistoryItem />;
  else if (Client) comp = <ClientHistoryItem />;
  else if (Contract) comp = <ContractHistoryItem />;
  else if (Billing) comp = <BillingHistoryItem />;
  else if (Deal) comp = <DealHistoryItem />;
  else if (Note) comp = <NoteHistoryItem />;
	else if (Email) comp = <EmailHistoryItem />;
	else if(EmailConversation) comp = <EmailConversationHistoryItem />;

  return (
    <div
      className={classnames("ar-history-item", className, {
        "ar-history-item-note": Boolean(Note)
      })}
    >
      <HistoryItemIndexContext.Provider value={index}>
        <HistoryItemProvider value={item}>{comp}</HistoryItemProvider>
      </HistoryItemIndexContext.Provider>
    </div>
  );
};
